import createIcon from '../../createIcon';

/**
 * @component @name SortingDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi4yNSAxNUg4LjI1VjEzSDIuMjVWMTVaTTIuMjUgM1Y1SDE4Ljc1VjNIMi4yNVpNMi4yNSAxMEgxMi43NVY4SDIuMjVWMTBaIiBmaWxsPSIjMTYxNjE2Ii8+CjxwYXRoIGQ9Ik0yMS43NSAxNkwyMC4yNjk0IDE0LjU5TDE3LjU1MDMgMTcuMTdWOEgxNS40NTAyVjE3LjE3TDEyLjczMDYgMTQuNTlMMTEuMjUgMTZMMTYuNTAwMiAyMUwyMS43NSAxNloiIGZpbGw9IiMxNjE2MTYiLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SortingDown = createIcon('SortingDown', [
  [
    'path',
    {
      d: 'M2.25 15H8.25V13H2.25V15ZM2.25 3V5H18.75V3H2.25ZM2.25 10H12.75V8H2.25V10Z',
      key: '1tb7my',
    },
  ],
  [
    'path',
    {
      d: 'M21.75 16L20.2694 14.59L17.5503 17.17V8H15.4502V17.17L12.7306 14.59L11.25 16L16.5002 21L21.75 16Z',
      key: '354fbf',
    },
  ],
]);

export default SortingDown;
